module.exports = __webpack_public_path__ + "static/img/scangzh.3e51cdaa.png";